import { render } from "./AiCreditBadge.vue?vue&type=template&id=21a0511c&scoped=true"
import script from "./AiCreditBadge.vue?vue&type=script&lang=js"
export * from "./AiCreditBadge.vue?vue&type=script&lang=js"

import "./AiCreditBadge.vue?vue&type=style&index=0&id=21a0511c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a0511c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
